
angular.module('trainerWebApp.services')
    .factory('yammerService', ['$resource', 'errorHandler', function ($resource, errorHandler) {


  var yammerUsersResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/user/');
  var yammerCourseUsersResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/user/course/:courseId');
  var yammerUsersGroupResources = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/user/:groupId');
  var yammerTokenResources = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/token/');
  var yammerNetworkResources = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/network/');
  var yammerGroupsResources = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/group/');
  var yammerUserInvitationResources = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/yammer/user/invitation');

  return {
    getYammerUsers:function (options, resultCb, errorCb) {
      options = _.defaults(options, { pageId: 1, permalink: '' });

      return yammerUsersResource.get(options, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    getYammerCourseUsers:function (courseId, options, resultCb, errorCb) {
      options = _.defaults(options, { courseId:courseId, pageId:1, permalink:'' });

      return yammerCourseUsersResource.get(options, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    saveYammerToken:function (token, resultCb, errorCb) {
      return yammerTokenResources.save({token:token}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    getYammerNetworks:function (resultCb, errorCb) {
      return yammerNetworkResources.get({}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    getYammerGroups:function (permalink, resultCb, errorCb) {
      return yammerGroupsResources.get({permalink:permalink}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    getYammerUsersInGroup:function (groupId, options, resultCb, errorCb) {
      options = _.defaults(options, { groupId:groupId, pageId:1, permalink:'' });

      return yammerUsersGroupResources.get( options, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    },
    inviteYammerUsers:function(options, resultCb, errorCb){
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var postOptions = _.defaults(options, {
        permalink:'',
        courseIds:[],
        requiredCourseIds:[],
        seriesIds:[],
        clientDatestamp:dateString,
        users:[],
        groupIds:[],
        batchId:''
      });

      return yammerUserInvitationResources.save(postOptions, resultCb || angular.noop, errorHandler.validationFaultServerErrorHandler(errorCb));
    }


  };
}]);
